// 2020/03/13 - adding prod.
// When a limited product is added to the cart from the collection page's quickview, disable the add to cart button when the limit is reached
function plusCollectionAdd (event) {
  var plus_variant_id = event.data.param1;
  var plus_limit = event.data.param2;
  // console.info('plusCollectionAdd - '+plus_limit);
  setTimeout(function() {
    $.ajax({
      async: false,
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (data) {
        var length = data.items.length;
        for (var i=0; i<length; i++) {
          // console.info('plusCollectionAdd - '+i);
          if (data.items[i].variant_id == plus_variant_id) {
            plus_remaining = (plus_limit - data.items[i].quantity);
            if (plus_remaining < 1) {
              // console.info('collecion');
              $('#plus_limited-'+plus_variant_id).attr('disabled','disabled').html(" {{ 'plus.products.quantity_maximum_message' | t: quantity_max: settings.plus_qty_limit_max }} ").addClass('Button--secondary').removeClass('Button--primary');
            }
          }
        }
      }
    });
  },1000);
}

// When the limited product is at its limit, set the quantity selector's only valid input to 0
function plusProductOverLimit() {
  $('input.QuantitySelector__CurrentQuantity').val(0).attr('pattern','[]{0}');
}

// When the limited product is under the limit, set the quantity selector to accept any number between 0 and the limit
function plusProductUnderLimit(item_quantity, plus_variant_id, plus_limit) {
  // console.info('****** limit ****** - '+plus_limit);
  var plus_remaining = (plus_limit - item_quantity);
  $('input.QuantitySelector__CurrentQuantity').attr('pattern','[0-'+plus_remaining+']{1}');
}

// When the limited product gets added to the cart, if it is under the limit, set the quantity selector to accept any number between 0 and the limit
function plusProductAdd(event) {
  var plus_variant_id = event.data.param1;
  var plus_limit = event.data.param2;
  // console.info('plusProductAdd - '+event.data.param2);
  setTimeout(function() {
    $.ajax({
      async: false,
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (data) {
        var length = data.items.length;
        for (var i=0; i<length; i++) {
          if (data.items[i].variant_id == plus_variant_id){
            plus_remaining = (plus_limit - data.items[i].quantity);
            $('input.QuantitySelector__CurrentQuantity').attr('pattern','[0-'+plus_remaining+']{1}');
          }
        }
      }
    });
  },1000);
}

// When the cart page quantity selector gets increased over a product's limit, disable the checkout button and remove over limit items from the cart
// When the selector is at the limit, disable the + button so it can't be increased that way
function plusCartLimit(plus_id,plus_limit) {
  // console.info('plusCartLimit - '+plus_id+' - '+plus_limit)
  if ($('.plus-quantity-with-limit .QuantitySelector__CurrentQuantity').val() > plus_limit) {
    $('button.Cart__Checkout').attr('disabled','disabled');
    $('button.Cart__Checkout').css({'cursor' : 'not-allowed', 'pointer-events' : 'none'});
    jQuery.post('/cart/update.js','updates['+plus_id+']='+plus_limit+'');
    // console.info('if - '+plus_id)
  } else if ($('.plus-quantity-with-limit .QuantitySelector__CurrentQuantity').val() == plus_limit) {
    $('.plus-quantity-with-limit .QuantitySelector__Button[data-quantity="'+plus_limit+'"]').each(function(){
      $(this).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    })
    // $('.plus-quantity-with-limit .QuantitySelector__Button').eq(1).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    // $('.plus-quantity-with-limit .QuantitySelector__Button').eq(3).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    // console.info('else - '+plus_id)
  }
}
